import { log } from '../../services/utils';

import { controller } from '../../contexts/SubmissionsContext';

import { noraApiRequest } from './';

export const getDocument = async submissionID => {
	log( 'getDocument' );
	const response = await noraApiRequest( {
		method: 'GET',
		url: `submissions/${ submissionID }`,
		signal: controller.signal
	} );

	return response.data;
};

export const deleteSubmission = async id => {
	log( '* delete submission' );
	const response = await noraApiRequest( {
		method: 'DELETE',
		url: `/submissions/${ id }`,
		signal: controller.signal
	} );

	return response.data;
};

export const updateSubmissionModuleData = async (
	submissionID,
	moduleID,
	data
) => {
	log( 'updateModuleData' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: `submissions/${ submissionID }/modules/${ moduleID }`,
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const getSubmissionTypes = async programId => {
	log( 'getSubmissionTypes' );
	const response = await noraApiRequest( {
		method: 'GET',
		url: 'submissions/types',
		params: { programId },
		signal: controller.signal
	} );

	return response.data;
};

export const getSubmissionHistory = async id => {
	log( '* get submission history' );
	const response = await noraApiRequest( {
		method: 'GET',
		url: `/submissions/programDocument/${ id }/history`,
		signal: controller.signal
	} );

	return response.data;
};

export const getQuickForms = async () => {
	log( '* get quick forms' );
	const response = await noraApiRequest( {
		method: 'GET',
		url: '/submissions/quickforms',
		signal: controller.signal
	} );

	return response.data;
};

export const createSubmission = async ( id, data ) => {
	log( '* get submission history' );
	const response = await noraApiRequest( {
		method: 'POST',
		url: `/submissions/programDocument/${ id }`,
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const createQuickformSubmission = async id => {
	log( '* get submission history' );
	const response = await noraApiRequest( {
		method: 'POST',
		url: `/submissions/programDocument/${ id }/quickform`,
		signal: controller.signal
	} );

	return response.data;
};

export const submit = async data => {
	log( 'submitSubmission' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: '/submissions/',
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const checkIntelligence = async ( submissionId, moduleId, data ) => {
	log( 'checkIntelligence' );
	const response = await noraApiRequest( {
		method: 'POST',
		url: `/submissions/${ submissionId }/module/${ moduleId }/intelligence`,
		data,
		signal: controller.signal
	} );

	return response.data;
};
